import { Pressable, View } from "react-native";

import { Text } from "@/components/ui/text";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import { SettingsChevron } from "./settings";

export type SelectOption = {
    id: number;
    label: string;
};

type EnumSelectProps = {
    options: SelectOption[];
    value: number | null;
    placeholder?: string;
    onPress: () => void;
    testID?: string;
};

export function buildEnumSelectionLabel(
    options: SelectOption[],
    value: number | null,
    placeholder: string,
): string {
    if (value == null) {
        return placeholder;
    }

    return options.find((option) => option.id === value)?.label ?? placeholder;
}

/**
 * Summary row for enum fields. Tapping opens a dedicated selection screen
 * with explanatory text and a list of options.
 */
export function EnumSelect({
    options,
    value,
    placeholder,
    onPress,
    testID,
}: EnumSelectProps) {
    const { t } = useTranslation();
    const tPlaceholder = placeholder ?? t("ui.selectOneOption");
    const label = buildEnumSelectionLabel(options, value, tPlaceholder);
    const hasSelection = value != null;

    return (
        <View className="w-full">
            <Pressable
                accessibilityRole="button"
                onPress={onPress}
                className={cn("flex-row items-center justify-between pr-2")}
            >
                <Text
                    testID={testID}
                    className={cn(
                        hasSelection
                            ? "text-foreground"
                            : "text-muted-foreground",
                    )}
                >
                    {label}
                </Text>
                <SettingsChevron />
            </Pressable>
        </View>
    );
}
